import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { selectCountry } from '../../../../common/category/store/slice'
import { getUserProfileThunk } from '../../../../common/category/store/thunk'
import { Loading } from '../../../../common/loading'
import { DEFAULT_CODE } from '../../../../layout/header/search/constants'
import { selectReportLoading } from '../store/slice'
import { getProducts } from '../store/thunk'
import { BlockBusinessService } from './BlockBusinessService'
import { BlockReport } from './BlockReport'

export const PreviewRight = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const companyId = searchParams.get('companyId')

  const locale = useSelector((state) => state.i18n.locale)
  const country = useSelector(selectCountry)
  const reportLoading = useSelector(selectReportLoading)

  useEffect(() => {
    if (!country.code || country.code === DEFAULT_CODE) return

    dispatch(
      getProducts({
        CountryCode: country.code,
        CompanyId: companyId,
        Page: 1,
        PageSize: 50,
      }),
    )
  }, [country, companyId, locale])

  useEffect(() => {
    dispatch(getUserProfileThunk())
  }, [locale])

  return (
    <div className="flex1 positionRelative">
      {reportLoading && <Loading />}
      {!reportLoading && (
        <>
          <BlockReport />
          <BlockBusinessService />
        </>
      )}
    </div>
  )
}
